import fetchWrapper from './fetch-wrapper';
import { service, handleErrors, normalizeResponse } from './apiServices';
import config from 'config';

const {
    HOST: { APIM_BASE_DOMAIN_URL },
    isLocal
} = config;

const COMPANY_CONFIG_API_URL = `${APIM_BASE_DOMAIN_URL}/hrcompanyconfig/`;

export function loadClientPrivilege(companyId, privilegeId) {
	let action = `api/v1/Security/ClientPrivileges?companyId=${companyId}&privilegeId=${privilegeId}`;

	return fetchWrapper(service(COMPANY_CONFIG_API_URL, action))
		.then(handleErrors)
		.then(normalizeResponse);
}